import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Header } from "../../../components/header";
import { NotifyList } from "./notify-list";

export const NotifyPage = () => {
  return (
    <>
      <Header />
      <Container fluid className="notify-page">
        <Row>
          <Col sm={12} md={12} className="py-3">
            <NotifyList />
          </Col>
        </Row>
      </Container>
    </>
  );
};
